(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* Le lien natif reste le recours. L’API officielle n’est appelée qu’une fois
     Klaviyo chargé ; aucune file d’ouverture différée ni chargeur supplémentaire. */
  const newsletterRequests = new WeakMap();
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-k9-newsletter]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    let returnTarget = link;
    const fallback = () => {
      if (destination.origin === location.origin && destination.pathname === location.pathname) {
        const target = document.getElementById(destination.hash.slice(1));
        if (target) {
          history.pushState(null, '', destination.hash);
          target.scrollIntoView({ block: 'center', behavior: 'instant' });
          const field = target.querySelector('input[type="email"]');
          returnTarget = field || target;
          if (!field) target.tabIndex = -1;
          returnTarget.focus({ preventScroll: true });
          return;
        }
      }
      location.assign(destination.href);
    };
    event.preventDefault();
    event.stopImmediatePropagation();
    const formId = link.dataset.k9NewsletterForm;
    if (!formId || window.self !== window.top || typeof window._klOnsite?.openForm !== 'function' || typeof window._klOnsite?.push !== 'function') { fallback(); return; }
    const previous = newsletterRequests.get(link);
    if (previous) {
      if (previous.pending) return;
      previous.cleanup();
    }
    const state = { pending: true };
    newsletterRequests.set(link, state);
    link.setAttribute('aria-busy', 'true');
    let opened = false;
    const cleanup = () => {
      clearTimeout(timer);
      window.removeEventListener('klaviyoForms', onForm);
      window.removeEventListener('pagehide', cleanup);
      newsletterRequests.delete(link);
      link.removeAttribute('aria-busy');
    };
    const onOpened = () => {
      if (newsletterRequests.get(link) !== state) return;
      opened = true;
      state.pending = false;
      clearTimeout(timer);
      link.removeAttribute('aria-busy');
    };
    const onForm = ({ detail }) => {
      if (detail?.formId !== formId) return;
      if (detail.type === 'open') {
        onOpened();
      }
      if (detail.type === 'close') { cleanup(); if (opened && returnTarget.isConnected) returnTarget.focus({ preventScroll: true }); }
    };
    /* Klaviyo peut ne pas confirmer l’ouverture. Libérer la prochaine tentative,
       sans texte ajouté ni navigation différée ; une ouverture tardive reste suivie. */
    const timer = setTimeout(() => {
      link.removeAttribute('aria-busy');
      state.pending = false;
    }, 1800);
    state.cleanup = cleanup;
    window.addEventListener('klaviyoForms', onForm);
    window.addEventListener('pagehide', cleanup, { once: true });
    try { window._klOnsite.push(['openForm', formId, onOpened]); }
    catch (_) { cleanup(); fallback(); }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }

      this.setHeaderHeight();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      // Le rootMargin à -100% fait en sorte que l'observer ne se déclenche
      // que lorsque le header est complètement sorti de l'écran.
      const observer = new IntersectionObserver((entries) => {
        this.header.classList.toggle('shopify-section-header-sticky', !entries[0].isIntersecting);
      }, { rootMargin: '-100% 0px 0px 0px' });

      observer.observe(this.header);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
